<template>
  <div>
    <div class="overlayMask"></div>
    <!-- @click="closePopup" -->
    <div class="salesgear-upgrade-popup">
      <div class="ae-popup-card popup-animate popup-scale-in">
        <div class="ae-title">
          <i class="material-icons closePopup" @click="closePopup">close</i>
          <h4 class="ae-app-name">
            <img src="@/assets/images/salesgearFullLogo.png" />
          </h4>
          <h4>
            Upgrade to continue
          </h4>
        </div>
        <div class="ae-popup-body">
          <p class="ae-desc">
            You have hit the limit of 100 contacts in the free plan.
          </p>
          <div class="btnSection">
            <button
              class="but btnSalesgear wiggle"
              @click="redirectToSalesgearPricing"
              type="button"
            >
              Upgrade Now
            </button>
            <p class="about-policy">
              No Contracts. No Obligations. Cancel Anytime.
            </p>
          </div>
        </div>
        <div class="ae-footer">
          <img
            src="@/assets/icons/png/aeContactUpgrade.png"
            class="contact-upgrade-img"
          />
          <img src="@/assets/icons/png/bgDotted.png" class="bg-dotted" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shareFunction from '@/assets/util/functions'
import { MxEvent } from '@/assets/util/constants/analytics'
import { SALESGEAR_URL } from '@/assets/util/constants/constants'

export default {
  name: 'SalesgearDuplicateContactPopup',
  components: {},
  props: [],
  data: function() {
    return {
      type: this.expContactType
    }
  },
  computed: {
    expContactType() {
      return this.$store.state.salesgear.expContactType
    }
  },
  methods: {
    closePopup() {
      this.$store.state.salesgear.isContactLimit = false
    },
    redirectToSalesgearPricing() {
      this.$store.state.salesgear.salesgearBanner = false
      shareFunction.track(
        MxEvent.aeContactUpgradeRedirect,
        { pageType: this.pageType },
        this.$store.state
      )
      this.$store.state.salesgear.isContactLimit = false
      window.open(`${SALESGEAR_URL}/pricing`, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.overlayMask {
  @include overlay(rgb(0, 0, 0, 0.85), 10, fixed);
}
.salesgear-upgrade-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  will-change: transform;
  width: 84%;
  max-width: 360px;
  z-index: 11;
  margin: 0 auto;
  .ae-popup-card {
    background: $white;
    color: $text-dark;
    padding: 20px 30px 0;
    border-radius: 6px;
    letter-spacing: 0.3px;
    transition: all 300ms ease;
    @include relBlock;
    will-change: auto;
    .ae-title {
      will-change: auto;
      @include relBlock;
      i {
        position: absolute;
        right: -16px;
        top: -10px;
        will-change: auto;
      }
      h4 {
        line-height: 1.3;
        font-size: 20px;
        margin: 0;
        will-change: font-size;
        padding-top: 10px;
        letter-spacing: 0.5px;
        color: $title-dark;
        padding-bottom: 10px;
        &.ae-app-name {
          padding-top: 0px;
          padding-bottom: 0px;
          margin-bottom: 6px;
          @include flex-align-path-justify(center, row, flex-start);
          span.text {
            margin-left: 8px;
          }
        }
        img {
          @include wt-ht(120px, auto);
        }
      }
    }
    .ae-popup-body {
      @include relBlock;
      will-change: auto;
      padding: 20px 0;
      .ae-desc {
        margin: 0;
        font-size: 16px;
        will-change: font-size;
        line-height: 1.4;
        padding-bottom: 10px;
      }
      .btnSection {
        @include relBlock;
        padding-top: 20px;
        .btnSalesgear {
          padding: 10px 15px;
          letter-spacing: 0.3px;
          font-size: 16px;
          will-change: font-size;
          &:hover {
            box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
          }
        }
        .about-policy {
          font-size: 14px;
          margin: 6px 0 0;
        }
      }
    }
    .ae-footer {
      @include relBlock;
      margin-top: 10px;
      .contact-upgrade-img {
        @include relBlock;
        width: 169px;
        height: 100%;
        will-change: width;
        margin: 0 auto;
      }
      .bg-dotted {
        position: absolute;
        bottom: 0;
        height: 100%;
        right: -30px;
        z-index: -1;
      }
    }
  }
}
</style>
